var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"-2px","margin-top":"-2px"}},[[_c('v-label',[_c('b',[_vm._v(_vm._s(_vm.label))])]),_c('v-select',{ref:"sgeneric",attrs:{"items":_vm.items,"chips":"","multiple":""},model:{value:(_vm.valueLocal),callback:function ($$v) {_vm.valueLocal=$$v},expression:"valueLocal"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }